import React from 'react';
import { Link } from "react-router-dom";
import { Dropdown, Header, Segment } from "semantic-ui-react";

const SiteHeader = () => (
  <Segment inverted className="MenuBar" textAlign="center">
    <Header className="MenuBarHeader" size='huge' content={'\uFDFD'} />
    <Dropdown floating selection text='Menu' className="MenuBarDropdown">
      <Dropdown.Menu>
        <Dropdown.Item icon="home" text='Home' as={Link} to="/" />
        <Dropdown.Item icon="list" text='Program' as={Link} to="/program" />
        <Dropdown.Item icon="book" text='Tafsir' as={Link} to="/tafsir" />
        <Dropdown.Item icon="pencil" text='Tajweed' as={Link} to="/tajweed" />
        <Dropdown.Item icon="list ol" text='Hifth' as={Link} to="/hifth" />
        <Dropdown.Item icon="checkmark box" text='Trivia' as={Link} to="/trivia" />
        <Dropdown.Item icon="thumbs up outline" text='Reviews/Feedback' as={Link} to="/contact" />
      </Dropdown.Menu> 
    </Dropdown>
  </Segment>
)
export default SiteHeader;

